import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { usePagePermissions } from 'hooks/usePagePermissions';

const GLOBAL_ROUTE_TITLES = [
  { match: '/dashboard', title: 'Dashboard Principal' },
  { match: '/perfil', title: 'Meu Perfil' },
  { match: '/configuracoes', title: 'Configurações' },
  { match: '/gestao-solicitacoes', title: 'Gestão de Solicitações' },
  { match: '/gerenciar-inscricoes', title: 'Gerenciar Inscrições' },
  { match: '/agente-ia', title: 'Central IA' },
  { match: '/teste-n8n', title: 'Teste N8N' }
];

const DIRECTORY_ROUTE_TITLES = [
  { match: '/financeiro', title: 'Visão Geral' },
  { match: '/contratos', title: 'Visão Geral' },
  { match: '/comercial', title: 'Visão Geral' },
  { match: '/operacional', title: 'Visão Geral' },
  { match: '/departamento-pessoal', title: 'Visão Geral' },
  { match: '/administrativo', title: 'Visão Geral' },
  { match: '/automacoes', title: 'Visão Geral' },
  { match: '/cobranca', title: 'Comissão de cobrança' },
  { match: '/operacional/estoque', title: 'Estoque' }
];

const getTitleFromRegistry = (pathname, routes) => {
  const exact = routes.find((route) => pathname === route.match);
  if (exact) return exact.title;

  const nested = routes.find((route) => pathname.startsWith(`${route.match}/`));
  if (nested) return nested.title;

  return null;
};

const resolvePageTitle = (pathname, currentDirectory) => {
  const globalTitle = getTitleFromRegistry(pathname, GLOBAL_ROUTE_TITLES);
  if (globalTitle) return globalTitle;

  const directoryTitle = getTitleFromRegistry(pathname, DIRECTORY_ROUTE_TITLES);
  if (directoryTitle) return directoryTitle;

  if (currentDirectory) return 'Visão Geral';

  return 'Dashboard Horizon';
};

const PageHeaderTitle = () => {
  const location = useLocation();
  const { getCurrentDirectory } = usePagePermissions();

  const currentDirectory = useMemo(
    () => getCurrentDirectory(location.pathname),
    [getCurrentDirectory, location.pathname]
  );
  const pageTitle = useMemo(
    () => resolvePageTitle(location.pathname, currentDirectory),
    [location.pathname, currentDirectory]
  );

  return (
    <div className="hidden w-full lg:block">
      <p className="mx-auto max-w-[min(46vw,620px)] truncate text-center text-[18px] font-semibold leading-tight text-[color:var(--text-primary)]">
        {pageTitle}
      </p>
    </div>
  );
};

export default PageHeaderTitle;
